import { render } from "./CopyToast.vue?vue&type=template&id=210b34c5&scoped=true"
import script from "./CopyToast.vue?vue&type=script&lang=js"
export * from "./CopyToast.vue?vue&type=script&lang=js"

import "./CopyToast.vue?vue&type=style&index=0&id=210b34c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210b34c5"]])

export default __exports__